import { INodeData, ILinkData } from '../context-detail-contracts';
import { EmployeeDataType } from '../../../../data-management/data-sources/sources/employees-data-source';
import { AccountDataType } from '../../../../data-management/data-sources/sources/accounts-data-source';

export enum AccountRelationshipType {
  None = 0,
  ADM = 1,
  AM = 2,
  HRProxy = 4,
  AccountSPOC = 8,
  ACL = 16,
}

export class AccountRelationshipData {
  constructor(public relationshipType: AccountRelationshipType) {}
}

export class AccountNodeData extends AccountRelationshipData implements INodeData {
  public x?: number;
  public y?: number;
  constructor(public element: AccountDataType | EmployeeDataType, relationshipType: AccountRelationshipType) {
    super(relationshipType);
  }
}

export class AccountLinkData extends AccountRelationshipData implements ILinkData<AccountNodeData> {
  public extraRelationships: AccountRelationshipType[] = [];

  constructor(public source: string | AccountNodeData, public target: string | AccountNodeData, relationshipType: AccountRelationshipType) {
    super(relationshipType);
  }
}
